import React from 'react';
import moment from 'moment';
import DateFormat from 'constants/date_format';

const PublishedDate = ({ date }) => (
  <span className="mr-4">
    {t('drafts.publishing.published')}{' '}
    {moment(date).format(DateFormat.MONTH_DAY_YEAR_SHORT)}{' '}
  </span>
);

export default PublishedDate;
